import { OutliersPnlStrategy } from 'widgets/outliers/data/pnlStrategies/index';
import isNil from 'lodash/isNil';

export const realisedPnlStrategy: OutliersPnlStrategy = {
    mapOrder: (order, benchmarkPrice, exchangeRate) => {
        const { avgPxC, fillQty } = order;

        if (
            isNil(avgPxC) ||
            isNil(benchmarkPrice) ||
            isNil(fillQty) ||
            fillQty === 0
        ) {
            return undefined;
        }

        const avgPx = avgPxC * exchangeRate;

        const pAndL = (fillQty ?? 0) * (avgPx - benchmarkPrice);
        const benchmarkPerformance =
            ((avgPx - benchmarkPrice) / benchmarkPrice) * 10000;
        return { benchmarkPerformance, pnl: pAndL };
    },
    requiredColumns: ['avgPxC', 'fillQty'],
};
